module.exports = __webpack_public_path__ + "img/logo_big.add2ab38.png";